import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import copy from "../lib/catalog/copy-strings.json";

export default function ShippingReturnsPage() {
        const c = copy.shipping;
        return (
                <PageShell title={c.title} path="/shipping-returns">
                        <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-[#F59E0B]">{c.eyebrow}</p>
                        <h1 className="mt-3 font-display uppercase leading-[0.95] text-[38px] md:text-[48px] lg:text-[64px]">
                                <span className="text-white">{c.heading_lead}</span>
                                <span className="text-[#F59E0B]">{c.heading_accent}</span>
                        </h1>

                        <section className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4">
                                {c.quick_ref.map((line) => (
                                        <div key={line} className="border border-white/10 p-4 font-mono text-[11px] tracking-[0.14em] uppercase text-white/80">{line}</div>
                                ))}
                        </section>

                        <section className="mt-14 space-y-4 text-white/80 leading-relaxed max-w-[68ch]" data-testid="shipping-logic">
                                {c.shipping_logic.map((p, i) => <p key={i}>{p}</p>)}
                        </section>

                        <section className="mt-14" data-testid="shipping-returns">
                                <h2 className="font-mono text-[12px] tracking-[0.16em] uppercase text-[#F59E0B]">Returns</h2>
                                <div className="mt-4 space-y-2 text-white/80 leading-relaxed max-w-[68ch]">
                                        {c.returns_body.map((p, i) => <p key={i}>{p}</p>)}
                                </div>
                        </section>

                        <section className="mt-14">
                                <h2 className="font-mono text-[12px] tracking-[0.16em] uppercase text-[#F59E0B]">Refund timing</h2>
                                <p className="mt-3 text-white/80 leading-relaxed max-w-[68ch]">{c.refund_body}</p>
                        </section>

                        <section className="mt-14" data-testid="shipping-cancellation">
                                <h2 className="font-mono text-[12px] tracking-[0.16em] uppercase text-[#F59E0B]">{c.cancellation_heading}</h2>
                                <div className="mt-4 space-y-2 text-white/80 leading-relaxed max-w-[68ch]">
                                        {c.cancellation_body.map((p, i) => <p key={i}>{p}</p>)}
                                </div>
                                <Link
                                        to="/preorder-policy"
                                        data-testid="shipping-preorder-policy-link"
                                        className="mt-4 inline-flex items-center border border-white/30 hover:border-[#F59E0B] hover:text-[#F59E0B] font-mono text-[11px] tracking-[0.16em] uppercase px-4 py-2.5 min-h-[44px] transition-colors"
                                >
                                        Read the Pre-Order Policy ➔
                                </Link>
                        </section>

                        <section className="mt-14" data-testid="shipping-contact">
                                <h2 className="font-mono text-[12px] tracking-[0.16em] uppercase text-[#F59E0B]">{c.contact_heading}</h2>
                                <p className="mt-3 text-white/80 leading-relaxed max-w-[68ch]">{c.contact_body}</p>
                        </section>

                        <section className="mt-14 flex flex-col sm:flex-row gap-4">
                                <Link to="/warranty" className="border border-[#F59E0B] text-[#F59E0B] hover:bg-[#F59E0B] hover:text-black font-mono text-[12px] tracking-[0.18em] uppercase px-5 py-3 min-h-[48px] inline-flex items-center">START A RETURN ➔</Link>
                                <Link to="/track-order" className="border border-white/30 hover:border-[#F59E0B] hover:text-[#F59E0B] font-mono text-[12px] tracking-[0.18em] uppercase px-5 py-3 min-h-[48px] inline-flex items-center">TRACK ➔</Link>
                        </section>
                </PageShell>
        );
}
